/**
 * Only allow safe URL schemes. Blocks javascript:, data:, vbscript:, etc.
 * Relative URLs and http(s)/mailto/irc are permitted.
 */
export function sanitizeUrl(url: string): string {
  const trimmed = String(url || '').trim();
  if (!trimmed) return '';

  // Allow anchors and relative paths
  if (
    trimmed.startsWith('#') ||
    trimmed.startsWith('/') ||
    trimmed.startsWith('./') ||
    trimmed.startsWith('../') ||
    trimmed.startsWith('?')
  ) {
    return trimmed;
  }

  try {
    const parsed = new URL(trimmed, 'https://example.invalid');
    const protocol = parsed.protocol.toLowerCase();
    if (
      protocol === 'http:' ||
      protocol === 'https:' ||
      protocol === 'mailto:' ||
      protocol === 'irc:' ||
      protocol === 'ircs:' ||
      protocol === 'xmpp:'
    ) {
      return trimmed;
    }
  } catch {
    return '';
  }

  return '';
}
